import { createContext, useContext, useState } from "react";

// Create context
const BannerContext = createContext();

// Create provider
export const BannerProvider = ({ children }) => {
  let data, isLoading;

  return (
    <BannerContext.Provider
      value={{
        data,
        isLoading,
      }}
    >
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => {
  return useContext(BannerContext);
};
